export default "__VITE_ASSET__54458c93__"